import { gql } from '@apollo/client';
import { useQuery, QueryResult, QueryHookOptions } from '@apollo/client';
import { Viewer } from '../../modules/viewer';

export const viewerQuery = gql`
  query Viewer($limit: Int, $current_organization_id: ID) {
    viewer(limit: $limit, current_organization_id: $current_organization_id) {
      id
      name
      email
      blockitAdmin
      profileLocationOnly
      organizations {
        id
        name
        slug
        role
        isActive
        isFree
        isCovid
        hasSso
        hasSsoStrict
        region {
          id
          name
        }
        locations {
          id
          name
          sends
          receives
        }
        featureFlags {
          id
          name
        }
        linkTypeAdministrationEnabled
        locationRequiredFieldsEnabled
        organizationInsurancesEnabled
        profileRequiredFieldsEnabled
        taxonomyAdministrationEnabled
        freePlanConfiguration {
          id
          name
          appointmentsPerWeek
          locations
          profiles
          providers
          users
        }
        cancelReasons {
          key
          value
        }
      }
    }
  }
`;

interface Data {
  viewer: Viewer;
}

type Options = QueryHookOptions<Data>;

type Result = QueryResult<Data>;

export const useViewerQuery = (options: Options): Result => {
  return useQuery<Data>(viewerQuery, options);
};
